enum SubscriptionType {
    Enterprise = "Enterprise",
    FreeTrial = "Free Trial",
    Individual = "Individual",
    Team = "Team",
}

export default SubscriptionType;
